import { Injectable } from "@angular/core";
import {
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from "@angular/router";
import { AuthService } from "./auth.service";
import { Observable, of } from "rxjs";
import { catchError, map } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class IpGuardService {
  constructor(private router: Router, private authService: AuthService) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return this.authService.isIPAllowed().pipe(
      map((response: boolean) => {
        console.log("ip respnse", response);
        if (response) {
          return true;
        }
        this.router.navigate(["/unauthorized"]);
        return false;
      }),
      catchError((error) => {
        this.router.navigate(["/unauthorized"]);
        return of(false);
      })
    );
  }
}
